/* eslint-disable linebreak-style */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
import { Sentry } from 'root/utils/raven';
import get from 'base-ui/dist/underline/get';
import map from 'base-ui/dist/underline/map';
import has from 'base-ui/dist/underline/has';

const ParseImgs = (htmlInReact = []) => {
  Sentry.addBreadcrumb({
    category: 'utils/ParseImgs',
    message: 'Added figure element in imgs on HTML',
    level: Sentry.Severity.Debug,
  });

  /**
   * Insert figure in image element
   * @param ctx
   * @param currentIndex
   */
  const addFigureImg = (ctx) => {
    const elements = [];
    let childrenElements = [];
    try {
      if (has(ctx, 'props.children') && Array.isArray(ctx?.props?.children)) {
        ctx?.props?.children?.forEach((child, index) => {
          if (child.type !== 'img' && ctx?.props?.children.length === index + 1) {
            childrenElements.push(child);
            const el = {
              type: ctx.type,
              props: {
                children: childrenElements
              }
            };
            elements.push(el);
            childrenElements = [];
          } else if (child.type !== 'img') {
            childrenElements.push(child);
          } else {
            if (childrenElements.length) {
              const el = {
                type: ctx.type,
                props: {
                  children: childrenElements
                }
              };
              elements.push(el);
            }
            const figure = {
              type: 'figure',
              props: {
                children: child,
                class: 'content-thumb'
              }
            };
            elements.push(figure);
            childrenElements = [];
          }
        });
      } else {
        elements.push(ctx);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
    return elements;
  };

  /**
   * Fix imgs in ul HTML added figure
   * @returns {[]}
   */
  const addFigureImgUl = (ctx) => {
    try {
      ctx?.props?.children?.forEach((child, index) => {
        if (['li'].includes(child.type) && has(child, 'props.children') && typeof (child.props.children) === 'object') {
          const returnFixImg = (v) => {
            const elements = [];
            if (Array.isArray(v)) {
              map(v, (el) => {
                if (typeof (el) === 'object' && Array.isArray(el.props.children)) {
                  const elChildren = [];
                  map(addFigureImg(el?.props?.children), (e) => elChildren.push(e));
                  elements.push({
                    ...el,
                    props: {
                      ...el.props,
                      children: elChildren
                    }
                  });
                } else {
                  elements.push(el);
                }
              });
            } else {
              map(addFigureImg(v?.props?.children), (e) => elements.push(e));
            }
            return elements;
          };

          ctx.props.children[index] = {
            ...child,
            props: {
              ...child.props,
              children: returnFixImg(child.props.children)
            }
          };
        }
      });
    } catch (error) {
      Sentry.captureException(error);
    }
    return ctx;
  };

  /**
   * Fix imgs in HTML added figure
   * @returns {[]}
   */
  const fixImgsElement = (html) => {
    const contentHTML = [];
    try {
      if (html.length) {
        for (let index = 0; index < html.length; index++) {
          const ctx = html[index];
          if (ctx !== '\n' && typeof (ctx) === 'object') {
            if (ctx.type === 'img') {
              const figure = {
                type: 'figure',
                props: {
                  children: ctx,
                  class: 'content-thumb'
                }
              };
              contentHTML.push(figure);
            } else if (['ul'].includes(ctx.type) && Array.isArray(ctx?.props?.children)) {
              contentHTML.push(addFigureImgUl(ctx));
            } else if (ctx?.props?.children && !Array.isArray(ctx?.props?.children) && !['figure', 'ul'].includes(ctx.type) && get(ctx, 'props.children.type') === 'img') {
              const figure = {
                type: 'figure',
                props: {
                  children: ctx?.props?.children,
                  class: 'content-thumb'
                }
              };
              contentHTML.push(figure);
            } else if (Array.isArray(ctx?.props?.children) && !['figure', 'ul'].includes(ctx.type) && ctx?.props?.children.find((e) => e.type === 'img')) {
              map(addFigureImg(ctx), (el) => contentHTML.push(el));
            } else {
              contentHTML.push(ctx);
            }
          } else {
            contentHTML.push(ctx);
          }
        }
      } else if (!Array.isArray(html)) {
        // Set as Array because htmlInReact is an object
        return [html];
      }
    } catch (error) {
      Sentry.captureException(error);
    }
    return contentHTML;
  };

  return fixImgsElement(htmlInReact);
};

export default ParseImgs;
